import { Flex, Heading, Text, Divider, Button, Image } from "@chakra-ui/react"

const PlusPerks = () => {
  return (
    <>
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/plus.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Interventii in caz de avarii ale instalatiei electrice interioare
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/plus.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Interventii in caz de avarii ale instalatiei sanitare de apa curenta
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
    </>
  )
}

const NormalHeaderText = () => {
  return (
    <>
      <Heading
        as="h2"
        size="md"
        marginTop="16px"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        CEZ Confort Asigurat
      </Heading>
      <Heading
        as="h3"
        size="lg"
        marginTop="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        Pret energie:{" "}
        <span style={{ color: "green" }}>0,654-0,712 lei/kWh*</span>
      </Heading>
      <Heading
        as="h3"
        size="md"
        marginTop="8px"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        La care se adauga abonament:{" "}
        <span style={{ color: "green" }}>0,2 lei/zi</span> in primele 6 luni**
      </Heading>
      <Text
        fontWeight="light"
        fontSize="xs"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        *Pretul include toate taxele si tarifele la momentul actual si variaza
        in functie de adresa locuintei.
      </Text>
      <Text
        fontWeight="light"
        fontSize="xs"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        **Incepand cu luna a 7-a, pretul abonamentului va fi de 0,52 lei/zi.
      </Text>
    </>
  )
}

const PlusHeaderText = () => {
  return (
    <>
      <Heading
        as="h2"
        size="md"
        marginTop="16px"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        CEZ Confort Asigurat <span style={{ color: "#FF5722" }}>Plus</span>
      </Heading>
      <Heading
        as="h3"
        size="lg"
        marginTop="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        Pret energie:{" "}
        <span style={{ color: "green" }}>0,654-0,712 lei/kWh*</span>
      </Heading>
      <Heading
        as="h3"
        size="md"
        marginTop="8px"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        La care se adauga abonament:{" "}
        <span style={{ color: "green" }}>0,3 lei/zi</span> in primele 6 luni**
      </Heading>
      <Text
        fontWeight="light"
        fontSize="xs"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        *Pretul include toate taxele si tarifele la momentul actual si variaza
        in functie de adresa locuintei.
      </Text>
      <Text
        fontWeight="light"
        fontSize="xs"
        marginBottom="8px"
        textAlign={["center", "center", "center", "left"]}
      >
        **Incepand cu luna a 7-a, pretul abonamentului va fi de 0,62 lei/zi.
      </Text>
    </>
  )
}

const Plan = ({ isPlus }) => {
  return (
    <Flex
      flexDirection="column"
      width={["100%", "100%", "80%", "30%"]}
      boxShadow="lg"
      marginTop="24px"
      marginBottom="24px"
      borderRadius="10px"
      paddingTop="16px"
      paddingBottom="16px"
      paddingLeft="24px"
      paddingRight="24px"
    >
      {isPlus ? <PlusHeaderText /> : <NormalHeaderText />}
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de incapacitate de munca in urma imbolnavirii cu
          virusul Sars-Cov-2
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de pierdere involuntara a locului de munca - somaj
          involuntar
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de spitalizare ca urmare a unui accident si ca
          urmare a imbolnavirii cu virusul Sars-CoV-2
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de invaliditate permanenta totala din accident
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de invaliditate temporara din accident
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      <Flex flexDirection="row" alignItems="center">
        <Image
          marginRight="16px"
          src="/cez-confort-asigurat/assets/disponibil.png"
          width="24px"
          height="24px"
        />
        <Text fontSize="xs">
          Acoperirea riscului de avarie a bunurilor electrocasnice in urma unor
          fenomene electrice
        </Text>
      </Flex>
      <Divider marginTop="4px" marginBottom="4px" />
      {isPlus ? <PlusPerks /> : <></>}
      <Flex justifyContent="center" alignItems="center" flexDirection="column">
        <Button
          colorScheme="brand"
          marginTop="16px"
          marginBottom="16px"
          onClick={(e) => {
            e.preventDefault()
            window.location.href =
              "https://mycez.cezinfo.ro/ro/web/client-non-cez/cere-oferta"
          }}
        >
          Solicita oferta
        </Button>
      </Flex>
    </Flex>
  )
}

export default Plan
